<template>
  <ul :class="$style.list">
    <li
      v-for="calendarSummary in calendarSummaries"
      :key="calendarSummary.guid"
      :class="$style.list__item"
    >
      <router-link
        :class="$style.calendarSummaryItem"
        :to="{
          name: 'calendarSettingDetail',
          params: {
            entranceGUID: route.params.entranceGUID,
            calendarGUID: calendarSummary.guid,
          },
        }"
      >
        <div :class="$style.calendarSummaryItem__status">
          <StateChip
            :text="statusString(calendarSummary.status)"
            :variation="statusVariation(calendarSummary.status)"
          />
        </div>

        <div>
          <p :class="$style.title">
            {{ calendarSummary.title }}
          </p>
          <p :class="$style.description" v-if="calendarSummary.description">
            {{ calendarSummary.description.slice(0, 30) }}
          </p>
        </div>
      </router-link>
    </li>
  </ul>
</template>

<script setup lang="ts">
import StateChip from '@/components/atoms/StateChip.vue'

import type {
  CalendarSummary,
  CalendarStatus,
} from '@/types/schema.generated.ts'
import { useRoute } from 'vue-router'

defineProps<{
  calendarSummaries: CalendarSummary[]
}>()

const route = useRoute('calendarSetting')

const statusString = (status: CalendarStatus): string => {
  if (status === 'ACTIVE') {
    return '有効'
  } else {
    return '無効'
  }
}

const statusVariation = (status: CalendarStatus) => {
  if (status === 'ACTIVE') {
    return 'positive'
  } else {
    return 'negative'
  }
}
</script>

<style lang="scss" module>
.text {
  color: $color-okaneko-blue;
  font-weight: bold;
}

.title {
  color: $color-okaneko-blue;
  font-weight: bold;
  font-size: 18px;
}

.description {
  color: $color-border-high-emphasis;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &:nth-child(n + 2) {
    margin-top: 16px;
  }

  &__item {
    padding: 8px;
    border: 1px solid $color-border-low-emphasis;
    border-radius: $border-radius-v2-base;

    &:hover {
      background-color: $color-surface-accent-primary-light;
    }
  }
}

.calendarSummaryItem {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
  padding-top: 8px;
  padding-bottom: 8px;

  &:hover {
    text-decoration: none;
  }

  &__status {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
  }
}
</style>
